// Configuration loaded from environment variables (populated from config.ini)
export const config = {
  // AWS Configuration
  AWS_REGION: process.env.REACT_APP_AWS_REGION || 'ca-central-1',
  
  // AWS Cognito Configuration
  // Note: These fallbacks are for development only. Production should always use environment variables.
  COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'ca-central-1_C6Adv0iTz',
  COGNITO_APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || 'maf9kp43cp2o10dc0pfmav2v',
  COGNITO_DOMAIN: process.env.REACT_APP_COGNITO_DOMAIN || 'https://ca-central-1c6adv0itz.auth.ca-central-1.amazoncognito.com',
  
  // Application URLs
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001',
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:80',
  
  // JWT Configuration
  JWT_ALGORITHM: process.env.REACT_APP_JWT_ALGORITHM || 'RS256',
  // Note: JWT_AUDIENCE fallback is for development only. Production should always use environment variables.
  JWT_AUDIENCE: process.env.REACT_APP_JWT_AUDIENCE || 'maf9kp43cp2o10dc0pfmav2v',
  
  // Application Settings
  APP_NAME: process.env.REACT_APP_APP_NAME || 'OARA Youth Innovation Lab',
  APP_VERSION: process.env.REACT_APP_APP_VERSION || '1.0.0',
  DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE === 'true' || false,
  
  // Security Settings
  PASSWORD_MIN_LENGTH: parseInt(process.env.REACT_APP_PASSWORD_MIN_LENGTH || '8'),
  SESSION_TIMEOUT: parseInt(process.env.REACT_APP_SESSION_TIMEOUT || '3600'),
  
  // Stripe Configuration
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''
};
